// extracted by mini-css-extract-plugin
export default {"WhatsApp":"WhatsApp_WhatsApp__YDKVc"};